module.exports = __webpack_public_path__ + "static/media/movieMarker.74e06430.png";